import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MediaPicker from '@/components/MediaPicker';
import { ChevronLeft, Send, ExternalLink } from 'lucide-react';

export default function Reader() {
  const [topic, setTopic] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const raw = sessionStorage.getItem('autoradko_topic');
    if (!raw) { nav('/'); return; }
    try { setTopic(JSON.parse(raw)); } catch (e) { nav('/'); }
  }, [nav]);

  const onMediaSelected = (media, extraInstruction) => {
    setPickerOpen(false);
    sessionStorage.setItem('autoradko_topic', JSON.stringify(topic));
    sessionStorage.setItem('autoradko_media', JSON.stringify(media));
    if (extraInstruction) {
      sessionStorage.setItem('autoradko_extra_instruction', extraInstruction);
    } else {
      sessionStorage.removeItem('autoradko_extra_instruction');
    }
    nav('/generate');
  };

  if (!topic) return null;

  return (
    <div className="mobile-shell">
      <header className="sticky top-0 z-30 bg-white/95 backdrop-blur-sm border-b border-slate-100 px-4 py-3 flex items-center justify-between">
        <button
          onClick={() => nav(-1)}
          data-testid="btn-back"
          className="flex items-center gap-1 text-slate-700 font-medium hover:text-blue-600 active:scale-95 transition"
        >
          <ChevronLeft size={22} /> Retour
        </button>
        <a
          href={topic.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-blue-600 text-sm font-semibold"
          data-testid="link-source"
        >
          Source <ExternalLink size={14} />
        </a>
      </header>

      <div className="px-5 pt-5 pb-32">
        <div className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold bg-red-50 text-red-700 uppercase tracking-wide">
          {topic.source}
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mt-3 leading-tight" data-testid="reader-title">
          {topic.title}
        </h1>
        <p className="text-xs text-slate-500 mt-2">
          {topic.published_at ? new Date(topic.published_at).toLocaleString('fr-FR') : ''}
        </p>

        {topic.image_url && (
          <img
            src={topic.image_url}
            alt=""
            className="w-full rounded-2xl mt-5 aspect-video object-cover bg-slate-100"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        )}

        <div className="mt-5 text-slate-700 leading-relaxed whitespace-pre-line" data-testid="reader-summary">
          {topic.summary}
        </div>

        <p className="text-sm text-slate-500 mt-6">
          Pour lire l'article complet, ouvrez la source originale.
        </p>
      </div>

      <div className="shell-dock bg-white border-t border-slate-200 p-4">
        <button
          onClick={() => setPickerOpen(true)}
          data-testid="btn-reader-publish"
          className="w-full bg-blue-600 text-white font-semibold py-3.5 rounded-xl hover:bg-blue-700 active:scale-95 transition flex items-center justify-center gap-2"
        >
          <Send size={18} /> Publier cet article
        </button>
      </div>
      <MediaPicker open={pickerOpen} onClose={() => setPickerOpen(false)} onSelect={onMediaSelected} />
    </div>
  );
}
